import PropTypes from 'prop-types';

import css from '../../styles/Video.module.css';
import CollapsedTopic from './CollapsedTopic';

const Topics = ({
  topics,
  onTopicVideoClick,
  onTopicClick,
  selectedVideoId,
  onTopicAttachmentClick,
  contentCreator,
  currentTopic,
}) => {
  return (
    <div className={css.topicsList}>
      {topics.map((topic) => {
        const isOpen =
          topic.videos.some((video) => video.id === selectedVideoId) ||
          topic.id === currentTopic.id;

        return (
          <CollapsedTopic
            currentTopic={currentTopic}
            contentCreator={contentCreator}
            key={topic.id}
            topic={topic}
            onTopicClick={onTopicClick}
            onTopicVideoClick={onTopicVideoClick}
            selectedVideoId={selectedVideoId}
            isOpenByDefault={isOpen}
            onTopicAttachmentClick={onTopicAttachmentClick}
          />
        );
      })}
    </div>
  );
};

Topics.propTypes = {
  topics: PropTypes.array.isRequired,
  onTopicClick: PropTypes.func.isRequired,
  onTopicVideoClick: PropTypes.func.isRequired,
  selectedVideoId: PropTypes.number,
  onTopicAttachmentClick: PropTypes.func.isRequired,
  contentCreator: PropTypes.object.isRequired,
};

export default Topics;
